// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1teCP","productName":"Table_productName__27zAZ"};